import classnames from "classnames";
import { Link } from "react-router-dom";

import LogoNL from "@/assets/images/logo-nl.svg";
import buttonStyles from "@/components/button/button.module.css";
import Icon from "@/components/icon/icon";
import { useDashboardPath } from "@/features/shared/navigation";

import UserMenu from "./user-menu/user-menu";
import styles from "./header.module.css";

const Header = () => {
  const dashboardViewPath = useDashboardPath();

  return (
    <div className={styles.header}>
      <div className={styles.inner}>
        <Link to="/admin" className={styles.logo}>
          <LogoNL />
        </Link>

        <div className={styles.right}>
          <UserMenu />
          <Link
            to={dashboardViewPath}
            className={classnames(buttonStyles.button, buttonStyles.primary)}
          >
            <Icon name="chevron-right" />
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Header;
